import './module.js';

// currencies module
import './currencies/module-load.js';

// uniswap module
import './uniswap/module-load.js';

// api gateway
import './control/controllers.js';
